Application.QrCode = {
    ready: function () {

        this.Contact.ready();
        this.Color.ready(Application.Signature.PreviewList);
        this.Loading.ready();

    }
};